import { useState } from "react";
import { FlashbarProps } from "@amzn/awsui-components-react";
import { FileProcessingUtil } from "../utils/fileProcessing";

export const useFileUpload = (
    onFlashbarUpdated?: (flashbarProps: Pick<FlashbarProps, "items"> | undefined) => void
) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [isFileUploading, setIsFileUploading] = useState<boolean>(false);

    const handleFileChange = ({ detail }: { detail: { value: File[] } }) => {
        if (detail.value.length > 0) {
            const file = detail.value[0];
            const validation = FileProcessingUtil.validateFile(file);

            if (validation.isValid) {
                setSelectedFile(file);
            } else {
                FileProcessingUtil.handleFileValidationError(validation.error!, onFlashbarUpdated);
                setSelectedFile(null);
            }
        } else {
            setSelectedFile(null);
        }
    };

    const extractTextFromFile = async (file: File): Promise<string> => {
        setIsFileUploading(true);
        try {
            const text = await FileProcessingUtil.extractTextFromDocx(file);
            return text;
        } catch (error) {
            FileProcessingUtil.handleFileProcessingError(error, onFlashbarUpdated);
            throw error;
        } finally {
            setIsFileUploading(false);
        }
    };

    const clearFile = () => {
        setSelectedFile(null);
        setIsFileUploading(false);
    };

    return {
        selectedFile,
        isFileUploading,
        handleFileChange,
        extractTextFromFile,
        clearFile
    };
};
